import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, sizes, width, media, helpers, font } from 'styles/variables';
import { log } from 'utils/log';
import GO from 'utils/GO';

export default props => {
	const StyledWrapper = styled.div`
		${media.small} {
			overflow-x: auto;
			margin-left: -${sizes[2]};
			margin-right: -${sizes[2]};
			padding: ${sizes[1]} 0;
		}
		.sp {
			grid-template-columns: repeat(3, 1fr);
			grid-gap: ${sizes[2]};
			${media.small} {
				padding-left: ${sizes[2]};
				padding-right: ${sizes[2]};
				grid-template-columns: 90% 90% 90% ${sizes[1]};
			}
			display: grid;
			&Item {
				background: ${colors.background[0]};
				border-radius: ${sizes[0]};
				overflow: hidden;
				padding: ${sizes[3]};
				${helpers.shadow};
				display: grid;
				grid-template-rows: auto auto 1fr auto;
				grid-gap: ${sizes[1]};
				line-height: 140%;
				&__image {
					${helpers.ratio11};
					margin: -${sizes[3]};
					margin-bottom: ${sizes[2]};
				}
				&__title {
					color: ${colors.pink.base};
					font-size: 1.5rem;
					font-weight: bold;
				}
				&__body {
					color: ${colors.foreground[1]};
					font-size: 0.8rem;
				}
				&__subtitle {
					color: ${colors.foreground[1]};
					font-size: 1rem;
					font-weight: bold;
					font-style: italic;
				}
			}
		}
	`;
	const ReviewsWrapper = styled.div`
		width: 100%;
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: ${sizes[2]};
		padding: ${sizes[2]};
		${media.notlarge} {
			grid-template-columns: 1fr;
		}
	`;
	const ReviewItem = styled.div`
		position: relative;
		display: grid;
		grid-template-rows: 1fr auto;
		grid-gap: ${sizes[3]};
		background: ${colors.background[0]};
		border-radius: ${sizes[0]};
		padding: ${sizes[3]};
		${helpers.shadow};
	`;
	const ReviewBody = styled.div`
		${media.notlarge} {
			margin-top: 40px;
		}
	`;
	const ReviewFooter = styled.div`
		display: grid;
		grid-template-columns: auto 1fr auto;
		align-items: center;
		.avatar {
			width: 48px;
			margin-right: ${sizes[1]};
			border-radius: 99px;
		}
		strong,
		small {
			display: block;
		}
		.rating {
			height: 24px;
			${media.notlarge} {
				position: absolute;
				top: ${sizes[3]};
				left: ${sizes[3]};
			}
		}
	`;

	const data = [
		{
			img1: '/sp/spa1.jpg',
			img2: '/sp/spb1.jpg',
			title: '245lbs → 145lbs',
			body:
				'Within a year I lost 100 lbs. Even after having a baby and gaining some weight back, I am not and will never be the person I was on the left.',
			subtitle: 'Cristina, 100lbs in 1 year',
		},
		{
			img1: '/sp/spa2.jpg',
			img2: '/sp/spb2.jpg',
			title: '195lbs → 135lbs',
			body:
				'I am so happy that fitness has changed my life. Now I value myself, my health and my happiness above all else.',
			subtitle: 'Elizabeth, 60lbs in 6 months',
		},
		{
			img1: '/sp/spa3.jpg',
			img2: '/sp/spb3.jpg',
			title: '205lbs → 125lbs',
			body:
				'The first week is always the hardest. No matter what you’re doing. But I promise it gets easier. Stay consistent.',
			subtitle: 'Meghan, 80lbs in 4 months',
		},
	];

	const renderReviewItem = (data, variant) => {
		return (
			<div className="sp">
				{data.map((item, index) => {
					return (
						<div className="spItem" key={index}>
							<div
								className="spItem__image"
								style={{ backgroundImage: `url(${item[`img${variant}`]})` }}
							/>
							<div className="spItem__title">{item.title}</div>
							<div className="spItem__body">{item.body}</div>
							<div className="spItem__subtitle">{item.subtitle}</div>
						</div>
					);
				})}
				<div className="sp__pagination" />
			</div>
		);
	};

	return (
		<StyledWrapper>
			{GO('SocialProof', 'PzrmOXAkSRublLoIcopGHw', [
				<ReviewsWrapper>
					{props.reviews.map(
						(item, index) =>
							index < 2 && (
								<ReviewItem key={index}>
									<ReviewBody>
										<h3>{item.headline}</h3>
										<small>{item.text}</small>
									</ReviewBody>
									<ReviewFooter>
										<div>
											<img className="avatar" alt={item.person} src={item.image.url} />
										</div>
										<div className="text">
											<strong>{item.person}</strong>
											<small>{item.subtitle}</small>
										</div>
										<img className="rating" src={item.rating.url} alt="rating" />
									</ReviewFooter>
								</ReviewItem>
							),
					)}
				</ReviewsWrapper>,
				<>{renderReviewItem(data, 1)}</>,
				<>{renderReviewItem(data, 2)}</>,
			])}
		</StyledWrapper>
	);
};
